import type { HTMLAttributes } from 'react';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';
import { ATextInteractiveProps } from '../../atoms/ATextInteractive/ATextInteractive.types';

export enum MListTextIconSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
}

export interface MListTextIconProps extends HTMLAttributes<HTMLDivElement> {
  size?: MListTextIconSize;
  aIcon?: Partial<AIconProps>;
  aTextInteractive: Partial<ATextInteractiveProps>;
}
